import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { css } from "@nju/css";
import { IInvoice } from "@nju/data-access-portal-payment";
import { portalRoutes } from "@nju/routes";
import { Box, GeneralErrorNotification, Loader, Panel } from "@nju/ui";
import { PaymentNotification } from "../components";
import { InvoiceHistoryRow } from "../invoice";
import { invoiceHistoryMachine } from "./invoiceHistoryMachine";

export function InvoiceHistoryPage() {
  const { push } = useRouter();

  const [
    {
      context: { invoices },
      matches,
    },
    send,
  ] = useMachine(invoiceHistoryMachine, {
    actions: {
      redirectToPayments: () => {
        push(portalRoutes.mojeKonto.platnosci.index.get());
      },
    },
  });

  const onInvoiceSend = React.useCallback(
    (id: string) => {
      send({ type: "SEND", id });
    },
    [send],
  );

  if (matches("error")) {
    return (
      <GeneralErrorNotification
        callback={() => {
          push(portalRoutes.mojeKonto.index.get());
        }}
      />
    );
  }

  if (matches("sent")) {
    return (
      <PaymentNotification
        callback={() => {
          send({ type: "BACK" });
        }}
        description="Dokument wysłaliśmy na Twojego maila."
        iconName="envelope-incircle-succes"
        textButton="wróć do faktur"
        title="dokument wysłany"
        userId={undefined}
      />
    );
  }

  return (
    <Panel>
      <table className={styles.table()}>
        {invoices.length > 0 && (
          <thead>
            <tr>
              <th>data wystawienia</th>
              <th>opis</th>
              <th>typ</th>
              <th>numer</th>
              <th>kwota</th>
              <th></th>
            </tr>
          </thead>
        )}
        <tbody>
          {invoices.map((el: IInvoice, index) => {
            return (
              <InvoiceHistoryRow
                invoice={el}
                isLastRow={index === invoices.length - 1}
                key={el.id}
                onInvoiceSend={onInvoiceSend}
              />
            );
          })}
          {invoices.length === 0 && (
            <tr className={styles.emptyTable()}>
              <td>
                <Box display="flex" justify="center">
                  <Loader />
                </Box>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Panel>
  );
}

const styles = {
  table: css({
    width: "100%",
    borderCollapse: "collapse",
    th: {
      textAlign: "left",
      py: "$15",
      px: "$5",
    },
    "@onlyMobile": {
      thead: {
        display: "none",
      },
    },
  }),
  emptyTable: css({
    py: "$30",
  }),
};
